(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/theme"), require("@splat/dialog"), require("core-js/modules/esnext.global-this.js"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("vue-router"), require("@splat/form"), require("@splat/form-item"), require("@splat/input"), require("@splat/textarea"), require("@splat/validator"));
	else if(typeof define === 'function' && define.amd)
		define([, , , "core-js/modules/esnext.global-this.js", , , , , , , , , , , ], factory);
	else if(typeof exports === 'object')
		exports["edit-item"] = factory(require("@splat/constant"), require("@splat/theme"), require("@splat/dialog"), require("core-js/modules/esnext.global-this.js"), require("csstips"), require("csx"), require("typestyle"), require("vue-property-decorator"), require("vue-tsx-support"), require("vue-router"), require("@splat/form"), require("@splat/form-item"), require("@splat/input"), require("@splat/textarea"), require("@splat/validator"));
	else
		root["edit-item"] = factory(root[undefined], root[undefined], root[undefined], root["core-js/modules/esnext.global-this.js"], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_theme__, __WEBPACK_EXTERNAL_MODULE__splat_dialog__, __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__, __WEBPACK_EXTERNAL_MODULE_csstips__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_typestyle__, __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__, __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__, __WEBPACK_EXTERNAL_MODULE_vue_router__, __WEBPACK_EXTERNAL_MODULE__splat_form__, __WEBPACK_EXTERNAL_MODULE__splat_form_item__, __WEBPACK_EXTERNAL_MODULE__splat_input__, __WEBPACK_EXTERNAL_MODULE__splat_textarea__, __WEBPACK_EXTERNAL_MODULE__splat_validator__) {
return /******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/item.tsx":
/*!**********************!*\
  !*** ./src/item.tsx ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_dialog__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/dialog */ "@splat/dialog");
/* harmony import */ var _splat_dialog__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_dialog__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var vue_router__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! vue-router */ "vue-router");
/* harmony import */ var vue_router__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(vue_router__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! vue-tsx-support/enable-check */ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js");
/* harmony import */ var vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support_enable_check__WEBPACK_IMPORTED_MODULE_17__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};












function shallowCopy(v) {
  return _objectSpread({}, v);
}

var EditItem = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(EditItem, _tsx$Component);

  var _super = _createSuper(EditItem);

  function EditItem() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, EditItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "title", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "submitCallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "copy", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "block", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "closeOnClickModal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "confirmButtonText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "confirmButtonLoadingText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "cancelButtonText", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "pushPath", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "dialogMaxWidth", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "innerValue", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "outerValue", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "show", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "submitting", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_panelLabel", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "_panelTitle", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18n", _locales__WEBPACK_IMPORTED_MODULE_11__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _this.i18n);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(EditItem, [{
    key: "handleValueChanged",
    value: function handleValueChanged() {
      this.innerValue = this.copy(this.value);
    }
  }, {
    key: "onInput",
    value: function onInput(v) {}
  }, {
    key: "onOpen",
    value: function onOpen() {}
  }, {
    key: "onClose",
    value: function onClose() {}
  }, {
    key: "panelLabel",
    get: function get() {
      var _panelLabel = this._panelLabel;
      return _panelLabel ? _panelLabel() : undefined;
    }
  }, {
    key: "panelTitle",
    get: function get() {
      var _panelTitle = this._panelTitle;
      return _panelTitle ? _panelTitle() : undefined;
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      if (!this.pushPath) {
        this.show = true;
        this.submitting = false;
      } else {
        var _this$$route, _this$$route$meta;

        (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.routerPushOrReplace)(this.$router, 'push', {
          path: this.pushPath,
          query: {
            prePath: 'true',
            title: (_this$$route = this.$route) === null || _this$$route === void 0 ? void 0 : (_this$$route$meta = _this$$route.meta) === null || _this$$route$meta === void 0 ? void 0 : _this$$route$meta.title
          }
        });
      }
    }
  }, {
    key: "handleDialogHide",
    value: function handleDialogHide() {
      this.show = false;
      this.submitting = false;
    }
  }, {
    key: "handleDialogOpen",
    value: function handleDialogOpen() {
      this.innerValue = this.copy(this.value);
      this.onOpen();
    }
  }, {
    key: "handleDialogClose",
    value: function handleDialogClose() {
      this.onClose();
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.handleDialogHide();
    }
  }, {
    key: "handleOk",
    value: function handleOk() {
      var innerValue = this.innerValue,
          outerValue = this.outerValue,
          onInput = this.onInput,
          handleDialogHide = this.handleDialogHide;

      if (innerValue) {
        onInput(outerValue || innerValue);
        handleDialogHide();
      }
    }
  }, {
    key: "handleUpdateInnerValue",
    value: function handleUpdateInnerValue(v) {
      this.innerValue = v;
    }
  }, {
    key: "editFormContext",
    value: function editFormContext() {
      return !!this.$scopedSlots.edit;
    }
  }, {
    key: "editDialogContext",
    value: function editDialogContext() {
      return !!this.$scopedSlots.editDialog;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var h = arguments[0];
      var show = this.show,
          value = this.value,
          title = this.title,
          block = this.block,
          submitCallback = this.submitCallback,
          innerValue = this.innerValue,
          placeholder = this.placeholder,
          closeOnClickModal = this.closeOnClickModal,
          handleClick = this.handleClick,
          handleDialogHide = this.handleDialogHide,
          handleDialogOpen = this.handleDialogOpen,
          handleDialogClose = this.handleDialogClose,
          handleCancel = this.handleCancel,
          handleOk = this.handleOk,
          handleUpdateInnerValue = this.handleUpdateInnerValue,
          panelLabel = this.panelLabel,
          panelTitle = this.panelTitle,
          confirmButtonText = this.confirmButtonText,
          confirmButtonLoadingText = this.confirmButtonLoadingText,
          cancelButtonText = this.cancelButtonText,
          submitting = this.submitting,
          pushPath = this.pushPath,
          theme = this.theme,
          dialogMaxWidth = this.dialogMaxWidth;
      return h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.editItemContainerClassName(theme), block && _style__WEBPACK_IMPORTED_MODULE_12__.editItemBlockContainerClassName, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('edit-item'))
      }, [h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.editItemContentClassName, block && _style__WEBPACK_IMPORTED_MODULE_12__.editItemBlockContentClassName)
      }, [h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(_style__WEBPACK_IMPORTED_MODULE_12__.editItemContentSlotClassName, block && _style__WEBPACK_IMPORTED_MODULE_12__.editItemBlockContentSlotClassName)
      }, [this.$scopedSlots.default(value) || placeholder]), h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_13__.classes)(pushPath ? 'chaitin-iconfont icon-test' : 'chaitin-iconfont icon-edit', _style__WEBPACK_IMPORTED_MODULE_12__.editItemIconClassName(theme), !this.$scopedSlots.default && _style__WEBPACK_IMPORTED_MODULE_12__.slotEmptyClassName, 'sl-custom-icon__edit-item__edit'),
        "on": {
          "click": handleClick
        }
      })]), this.editFormContext() ? h((_splat_dialog__WEBPACK_IMPORTED_MODULE_10___default()), {
        "attrs": {
          "maxWidth": dialogMaxWidth,
          "title": title || this.i18n.t.editItem.edit({
            item: panelLabel || panelTitle || ''
          }),
          "value": show,
          "beforeOk": function beforeOk() {
            return submitCallback ? innerValue ? submitCallback(innerValue).then(function (v) {
              _this2.outerValue = v;
              _this2.submitting = true;
            }) : Promise.reject('value not ready') : Promise.resolve();
          },
          "closeOnClickModal": closeOnClickModal,
          "confirmButtonText": confirmButtonText,
          "cancelButtonText": cancelButtonText,
          "confirmButtonLoadingText": confirmButtonLoadingText,
          "submitting": submitting
        },
        "on": {
          "input": handleDialogHide,
          "ok": handleOk,
          "cancel": handleCancel,
          "open": handleDialogOpen,
          "close": handleDialogClose
        }
      }, [innerValue ? h("div", [this.$scopedSlots.edit({
        value: innerValue,
        updateValue: handleUpdateInnerValue
      })]) : null]) : null, this.editDialogContext() ? innerValue ? this.$scopedSlots.editDialog({
        closeOnClickModal: closeOnClickModal,
        show: show,
        title: title || this.i18n.t.editItem.edit({
          item: panelLabel || panelTitle || ''
        }),
        onInput: handleDialogHide,
        onOk: handleOk,
        onCancel: handleCancel,
        onOpen: handleDialogOpen,
        onClose: handleDialogClose,
        value: innerValue,
        updateValue: handleUpdateInnerValue,
        beforeOk: function beforeOk() {
          return submitCallback ? innerValue ? submitCallback(innerValue).then() : Promise.reject('value not ready') : Promise.resolve();
        }
      }) : null : null]);
    }
  }, {
    key: "updateLang",
    value: function updateLang(l) {
      this.i18n.setLanguage(l);
    }
  }, {
    key: "mounted",
    value: function mounted() {
      if (this.i18nInjection && this.i18nInjection !== this.i18n) {
        this.i18nInjection.addSub(this.updateLang);
        this.i18n.setLanguage(this.i18nInjection.lang);
      }
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.i18nInjection) {
        this.i18nInjection.removeSub(this.updateLang);
      }
    }
  }]);

  return EditItem;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_15__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "title", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "submitCallback", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)({
  default: function _default() {
    return shallowCopy;
  }
})], EditItem.prototype, "copy", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)({
  default: '-'
})], EditItem.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "block", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "closeOnClickModal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "confirmButtonText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "confirmButtonLoadingText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "cancelButtonText", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "pushPath", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Prop)()], EditItem.prototype, "dialogMaxWidth", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Watch)('value', {
  immediate: true
})], EditItem.prototype, "handleValueChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Inject)({
  from: 'panelLabel',
  default: undefined
})], EditItem.prototype, "_panelLabel", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Inject)({
  from: 'panelTitle',
  default: undefined
})], EditItem.prototype, "_panelTitle", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('input')], EditItem.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('open')], EditItem.prototype, "onOpen", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Emit)('close')], EditItem.prototype, "onClose", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Inject)({
  from: 'i18nInjection',
  default: null
})], EditItem.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Provide)('i18nInjection')], EditItem.prototype, "i18nProvider", void 0);

EditItem = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_14__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_9___default())]
})], EditItem);
/* harmony default export */ __webpack_exports__["default"] = (EditItem);

/***/ }),

/***/ "./src/locales/index.ts":
/*!******************************!*\
  !*** ./src/locales/index.ts ***!
  \******************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I18nProvider": function() { return /* binding */ I18nProvider; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! core-js/modules/esnext.global-this.js */ "core-js/modules/esnext.global-this.js");
/* harmony import */ var core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_esnext_global_this_js__WEBPACK_IMPORTED_MODULE_3__);




var I18nProvider = /*#__PURE__*/function () {
  function I18nProvider(maps, _lang, fallback) {
    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, I18nProvider);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "maps", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "_lang", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "fallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_2__["default"])(this, "subs", new Set());

    this.maps = maps;
    this._lang = _lang;
    this.fallback = fallback;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(I18nProvider, [{
    key: "lang",
    get: function get() {
      return this._lang;
    }
  }, {
    key: "setLanguage",
    value: function setLanguage(lang) {
      if (this._lang === lang) return;
      this._lang = lang;
      this.subs.forEach(function (x) {
        return x(lang);
      });
    }
  }, {
    key: "addSub",
    value: function addSub(cb) {
      this.subs.add(cb);
    }
  }, {
    key: "removeSub",
    value: function removeSub(cb) {
      this.subs.delete(cb);
    }
  }, {
    key: "t",
    get: function get() {
      return this.maps[this.lang] || this.maps[this.fallback];
    }
  }]);

  return I18nProvider;
}();
var provider = new I18nProvider({
  'en-US': {
    editItem: {
      edit: function edit(options) {
        return ['edit ', options.item].join('');
      },
      cancel: 'Cancel',
      confirm: 'Ok'
    }
  },
  'zh-CHT': {
    editItem: {
      edit: function edit(options) {
        return ["\u7DE8\u8F2F", options.item].join('');
      },
      cancel: "\u53D6\u6D88",
      confirm: "\u78BA\u5B9A"
    }
  },
  'zh-CN': {
    editItem: {
      edit: function edit(options) {
        return ["\u7F16\u8F91", options.item].join('');
      },
      cancel: "\u53D6\u6D88",
      confirm: "\u786E\u5B9A"
    }
  }
}, globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN', globalThis.__splatI18nProvider ? globalThis.__splatI18nProvider.lang : 'zh-CN');
/* harmony default export */ __webpack_exports__["default"] = (provider);

/***/ }),

/***/ "./src/singleItem.tsx":
/*!****************************!*\
  !*** ./src/singleItem.tsx ***!
  \****************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/classCallCheck */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js");
/* harmony import */ var _babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @babel/runtime/helpers/createClass */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js");
/* harmony import */ var _babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @babel/runtime/helpers/assertThisInitialized */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");
/* harmony import */ var _babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @babel/runtime/helpers/inherits */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js");
/* harmony import */ var _babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @babel/runtime/helpers/possibleConstructorReturn */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js");
/* harmony import */ var _babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! @babel/runtime/helpers/getPrototypeOf */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js");
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @babel/runtime/helpers/typeof */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _splat_form__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! @splat/form */ "@splat/form");
/* harmony import */ var _splat_form__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_splat_form__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! @splat/form-item */ "@splat/form-item");
/* harmony import */ var _splat_form_item__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_splat_form_item__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! @splat/input */ "@splat/input");
/* harmony import */ var _splat_input__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_splat_input__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _splat_textarea__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! @splat/textarea */ "@splat/textarea");
/* harmony import */ var _splat_textarea__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_splat_textarea__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! @splat/theme */ "@splat/theme");
/* harmony import */ var _splat_theme__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_splat_theme__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! @splat/validator */ "@splat/validator");
/* harmony import */ var _splat_validator__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_splat_validator__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _locales__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./locales */ "./src/locales/index.ts");
/* harmony import */ var _style__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./style */ "./src/style.ts");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! vue-property-decorator */ "vue-property-decorator");
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! vue-tsx-support */ "vue-tsx-support");
/* harmony import */ var vue_tsx_support__WEBPACK_IMPORTED_MODULE_19___default = /*#__PURE__*/__webpack_require__.n(vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__);









function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0,_babel_runtime_helpers_getPrototypeOf__WEBPACK_IMPORTED_MODULE_5__["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0,_babel_runtime_helpers_possibleConstructorReturn__WEBPACK_IMPORTED_MODULE_4__["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var __decorate = undefined && undefined.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : (0,_babel_runtime_helpers_typeof__WEBPACK_IMPORTED_MODULE_7__["default"])(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};













var inputWidth = 258;
var triangleHeight = 10;

var SingleEditItem = /*#__PURE__*/function (_tsx$Component) {
  (0,_babel_runtime_helpers_inherits__WEBPACK_IMPORTED_MODULE_3__["default"])(SingleEditItem, _tsx$Component);

  var _super = _createSuper(SingleEditItem);

  function SingleEditItem() {
    var _this;

    (0,_babel_runtime_helpers_classCallCheck__WEBPACK_IMPORTED_MODULE_0__["default"])(this, SingleEditItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "value", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "type", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "readonly", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "inputType", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "autosize", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "placeholder", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "rule", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "submitCallback", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "footer", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "closeOnClickModal", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nInjection", void 0);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "i18nProvider", _locales__WEBPACK_IMPORTED_MODULE_15__["default"]);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "innerValue", '');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "show", false);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "popperElm", null);

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "position", {
      left: 0,
      top: 0
    });

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "popVerticalRelative", 'bottom');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "popHorizonRelative", 'left');

    (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_6__["default"])((0,_babel_runtime_helpers_assertThisInitialized__WEBPACK_IMPORTED_MODULE_2__["default"])(_this), "innerCompositionend", true);

    return _this;
  }

  (0,_babel_runtime_helpers_createClass__WEBPACK_IMPORTED_MODULE_1__["default"])(SingleEditItem, [{
    key: "handleValueChanged",
    value: function handleValueChanged() {
      this.innerValue = this.value;
    }
  }, {
    key: "onInput",
    value: function onInput(v) {}
  }, {
    key: "onClose",
    value: function onClose() {
      this.show = false;
      this.$refs.formItemRef.form.updateState({
        type: _splat_validator__WEBPACK_IMPORTED_MODULE_14__.Status.unknown
      });
      document.removeEventListener('click', this.handleClickEvent);
      document.removeEventListener('compositionstart', this.handleCompositionStart);
      document.removeEventListener('scroll', this.setPosition);
      document.removeEventListener('compositionend', this.handleCompositionEnd);
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(event) {
      if (event.code === 'Enter' && (event.ctrlKey || event.metaKey)) {
        this.innerValue += '\r\n';
      }

      if (this.innerCompositionend && event.code === 'Enter' && !event.shiftKey && !event.ctrlKey && !event.metaKey) {
        this.handleOk();
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this2 = this;

      this.show = true;
      this.setPosition();
      setTimeout(function () {
        document.addEventListener('click', _this2.handleClickEvent);
        document.addEventListener('compositionstart', _this2.handleCompositionStart);
        document.addEventListener('compositionend', _this2.handleCompositionEnd);
        document.addEventListener('scroll', _this2.setPosition);
      });
    }
  }, {
    key: "handleCancel",
    value: function handleCancel() {
      this.onClose();
      this.innerValue = this.value;
    }
  }, {
    key: "handleOnInput",
    value: function handleOnInput(v) {
      this.innerValue = v;
    }
  }, {
    key: "handleEmitInput",
    value: function handleEmitInput() {
      this.onInput("".concat(this.innerValue));
      this.onClose();
    }
  }, {
    key: "handleOk",
    value: function handleOk() {
      var _this3 = this;

      if (this.readonly || this.value === this.innerValue) {
        this.handleCancel();
        return;
      }

      var innerValue = this.innerValue,
          handleEmitInput = this.handleEmitInput,
          submitCallback = this.submitCallback;
      var validate = this.$refs.formRef.validateAll();
      if (!validate) return;

      if ((0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.isDef)(submitCallback)) {
        submitCallback(innerValue).then(handleEmitInput).catch(function (e) {
          var _this3$$refs$formItem;

          ;
          (_this3$$refs$formItem = _this3.$refs.formItemRef.form) === null || _this3$$refs$formItem === void 0 ? void 0 : _this3$$refs$formItem.updateState({
            type: _splat_validator__WEBPACK_IMPORTED_MODULE_14__.Status.failed,
            error: e
          });
        });
      } else {
        handleEmitInput();
      }
    }
  }, {
    key: "setPosition",
    value: function setPosition() {
      if (!this.show) return;
      var position = this.position;
      var elementRect = this.$refs.singleItemEdit.getBoundingClientRect();
      var formHeight = this.$refs.popover.getBoundingClientRect().height;

      if (elementRect.left + inputWidth - 14 > window.innerWidth) {
        // default padding is 14px, it should not at the edge
        position.left = elementRect.left - 220;
        this.popHorizonRelative = 'left';
      } else {
        position.left = elementRect.left - 30;
        this.popHorizonRelative = 'right';
      }

      if (elementRect.top + formHeight >= window.innerHeight - 86) {
        // 50 is meaningless, just make popover not show at the bottom in the viewport
        this.popVerticalRelative = 'top';
      } else {
        this.popVerticalRelative = 'bottom';
      }

      if (this.popVerticalRelative === 'top') {
        position.top = elementRect.top - formHeight - triangleHeight;
      } else {
        position.top = elementRect.top + elementRect.height + triangleHeight;
      }
    }
  }, {
    key: "render",
    value: function render(h) {
      var handleClick = this.handleClick,
          value = this.value,
          placeholder = this.placeholder,
          theme = this.theme,
          position = this.position;
      return h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_16__.singleItem
      }, [h("div", {
        "ref": 'popoverContainer',
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_16__.wrapPopClassName(this.show), 'popover')
      }, [h("div", {
        "ref": 'popover',
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_16__.formWrapperClassName(this.popVerticalRelative, this.popHorizonRelative), (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.style)({
          top: position.top,
          left: position.left,
          visibility: this.show ? 'initial' : 'hidden'
        }))
      }, [h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)('el-icon-close', _style__WEBPACK_IMPORTED_MODULE_16__.closeClassName),
        "on": {
          "click": this.handleCancel
        }
      }), h((_splat_form__WEBPACK_IMPORTED_MODULE_9___default()), {
        "ref": 'formRef',
        "attrs": {
          "formModel": {
            innerValue: this.innerValue
          }
        }
      }, [h((_splat_form_item__WEBPACK_IMPORTED_MODULE_10___default()), {
        "ref": 'formItemRef',
        "attrs": {
          "prop": 'innerValue',
          "rule": this.rule
        }
      }, [this.inputType === 'textArea' ? h(_splat_form_item__WEBPACK_IMPORTED_MODULE_10__.FormItemValidateStatus, [h((_splat_textarea__WEBPACK_IMPORTED_MODULE_12___default()), {
        "attrs": {
          "autosize": this.autosize,
          "value": "".concat(this.innerValue),
          "placeholder": placeholder
        },
        "nativeOn": {
          "keydown": this.handleKeyDown
        },
        "on": {
          "input": this.handleOnInput
        }
      })]) : h((_splat_input__WEBPACK_IMPORTED_MODULE_11___default()), {
        "nativeOn": {
          "keydown": this.handleKeyDown
        },
        "attrs": {
          "value": "".concat(this.innerValue),
          "placeholder": placeholder,
          "type": this.type
        },
        "on": {
          "input": this.handleOnInput
        }
      }, [this.$slots.prepend && h("div", {
        "slot": 'prepend'
      }, [this.$slots.prepend]), this.$slots.append && h("div", {
        "slot": 'append'
      }, [this.$slots.append])])])]), this.footer ? h("div", {
        "class": _style__WEBPACK_IMPORTED_MODULE_16__.footer
      }, [h("div", {
        "on": {
          "click": this.handleCancel
        }
      }, [_locales__WEBPACK_IMPORTED_MODULE_15__["default"].t.editItem.cancel]), h("div", {
        "on": {
          "click": this.handleOk
        },
        "class": _style__WEBPACK_IMPORTED_MODULE_16__.primaryButtonContainerClassName(theme)
      }, [_locales__WEBPACK_IMPORTED_MODULE_15__["default"].t.editItem.confirm])]) : null])]), h("div", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)('reference-wrapper', _style__WEBPACK_IMPORTED_MODULE_16__.editItemContainerClassName(theme), (0,_splat_constant__WEBPACK_IMPORTED_MODULE_8__.createSplatClassName)('edit-item'))
      }, [h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_16__.editItemContentClassName)
      }, [h("span", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_16__.editItemContentSlotClassName)
      }, [this.$slots.default || value]), this.readonly ? null : h("i", {
        "class": (0,typestyle__WEBPACK_IMPORTED_MODULE_17__.classes)(_style__WEBPACK_IMPORTED_MODULE_16__.editItemIconClassName(theme), this.show && _style__WEBPACK_IMPORTED_MODULE_16__.translucent, 'chaitin-iconfont icon-edit sl-custom-icon__edit-item__edit'),
        "on": {
          "click": handleClick
        },
        "ref": 'singleItemEdit'
      })])])]);
    }
  }, {
    key: "handleClickEvent",
    value: function handleClickEvent(e) {
      if (this.closeOnClickModal && this.show && e.target !== this.$refs.popover && !this.$refs.popover.contains(e.target)) {
        this.handleOk();
      }
    }
  }, {
    key: "handleCompositionStart",
    value: function handleCompositionStart() {
      this.innerCompositionend = false;
    }
  }, {
    key: "handleCompositionEnd",
    value: function handleCompositionEnd() {
      this.innerCompositionend = true;
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.popperElm = this.$refs.popoverContainer;
      document.body.appendChild(this.popperElm);
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      if (this.popperElm) {
        document.body.removeChild(this.popperElm);
      }
    }
  }]);

  return SingleEditItem;
}(vue_tsx_support__WEBPACK_IMPORTED_MODULE_19__.Component);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], SingleEditItem.prototype, "value", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: 'text'
})], SingleEditItem.prototype, "type", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: false
})], SingleEditItem.prototype, "readonly", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: 'input'
})], SingleEditItem.prototype, "inputType", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: function _default() {
    return {
      minRows: 2,
      maxRows: 8
    };
  }
})], SingleEditItem.prototype, "autosize", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: ''
})], SingleEditItem.prototype, "placeholder", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], SingleEditItem.prototype, "rule", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)()], SingleEditItem.prototype, "submitCallback", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: true
})], SingleEditItem.prototype, "footer", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Prop)({
  default: false
})], SingleEditItem.prototype, "closeOnClickModal", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Inject)({
  from: 'i18nInjection',
  default: null
})], SingleEditItem.prototype, "i18nInjection", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Provide)('i18nInjection')], SingleEditItem.prototype, "i18nProvider", void 0);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Watch)('value', {
  immediate: true
})], SingleEditItem.prototype, "handleValueChanged", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Emit)('input')], SingleEditItem.prototype, "onInput", null);

__decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Emit)('close')], SingleEditItem.prototype, "onClose", null);

SingleEditItem = __decorate([(0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_18__.Component)({
  mixins: [(_splat_theme__WEBPACK_IMPORTED_MODULE_13___default())]
})], SingleEditItem);
/* harmony default export */ __webpack_exports__["default"] = (SingleEditItem);

/***/ }),

/***/ "./src/style.ts":
/*!**********************!*\
  !*** ./src/style.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "editItemContainerClassName": function() { return /* binding */ editItemContainerClassName; },
/* harmony export */   "editItemBlockContainerClassName": function() { return /* binding */ editItemBlockContainerClassName; },
/* harmony export */   "editItemContentClassName": function() { return /* binding */ editItemContentClassName; },
/* harmony export */   "editItemBlockContentClassName": function() { return /* binding */ editItemBlockContentClassName; },
/* harmony export */   "editItemContentSlotClassName": function() { return /* binding */ editItemContentSlotClassName; },
/* harmony export */   "editItemBlockContentSlotClassName": function() { return /* binding */ editItemBlockContentSlotClassName; },
/* harmony export */   "editItemIconClassName": function() { return /* binding */ editItemIconClassName; },
/* harmony export */   "slotEmptyClassName": function() { return /* binding */ slotEmptyClassName; },
/* harmony export */   "singleItem": function() { return /* binding */ singleItem; },
/* harmony export */   "wrapPopClassName": function() { return /* binding */ wrapPopClassName; },
/* harmony export */   "formWrapperClassName": function() { return /* binding */ formWrapperClassName; },
/* harmony export */   "closeClassName": function() { return /* binding */ closeClassName; },
/* harmony export */   "translucent": function() { return /* binding */ translucent; },
/* harmony export */   "footer": function() { return /* binding */ footer; },
/* harmony export */   "primaryButtonContainerClassName": function() { return /* binding */ primaryButtonContainerClassName; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! csstips */ "csstips");
/* harmony import */ var csstips__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(csstips__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_4__);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var editItemContainerClassName = function editItemContainerClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.themeFontSize(theme)),
    lineHeight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.lineHeight)
  });
};
var editItemBlockContainerClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.block, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.topBottomPadding), (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.leftRightPadding)), {
  background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemColors.background.toString(),
  borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.raduisSize)
});
var editItemContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, csstips__WEBPACK_IMPORTED_MODULE_2__.center);
var editItemBlockContentClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)((0,csstips__WEBPACK_IMPORTED_MODULE_2__.width)((0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100)));
var editItemContentSlotClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  wordBreak: 'break-all'
});
var editItemBlockContentSlotClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flex);
var editItemIconClassName = function editItemIconClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(_objectSpread(_objectSpread({
    fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.fontSize),
    marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(_splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemSizes.iconMargin),
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.EditItemColors.themeFontColor(theme).toString(),
    cursor: 'pointer',
    alignSelf: 'flex-end'
  }, (0,_splat_constant__WEBPACK_IMPORTED_MODULE_1__.iconHoverTransform)(theme)), {}, {
    border: (0,csx__WEBPACK_IMPORTED_MODULE_3__.border)({
      color: 'transparent',
      style: 'solid',
      width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
    })
  }));
};
var slotEmptyClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  marginLeft: 0
});
var singleItem = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  $nest: {
    '& .popover': {
      display: 'none'
    }
  }
});
var wrapPopClassName = function wrapPopClassName() {
  var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    position: 'fixed',
    top: 0,
    left: 0,
    width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100),
    height: show ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.percent)(100) : undefined
  });
};
var formWrapperClassName = function formWrapperClassName(popVerticalRelative, popHorizonRelative) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    background: '#FFFFFF',
    boxShadow: '0 0 10px 0 rgba(0,0,0,0.14)',
    position: 'absolute',
    borderRadius: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(4),
    $nest: {
      '& .sl-id-form-item': {
        margin: '16px 14px 0 14px'
      },
      '&::before': {
        position: 'absolute',
        content: "''",
        width: 0,
        height: 0,
        top: popVerticalRelative === 'bottom' ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-10) : undefined,
        bottom: popVerticalRelative === 'top' ? (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-10) : undefined,
        left: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(popHorizonRelative === 'right' ? 30 : 228),
        borderBottom: popVerticalRelative === 'bottom' ? '10px solid #fff' : undefined,
        borderTop: popVerticalRelative === 'top' ? '10px solid #fff' : undefined,
        borderLeft: '5px solid transparent',
        borderRight: '5px solid transparent'
      }
    }
  });
};
var closeClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  position: 'absolute',
  top: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(8),
  right: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(8),
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(15),
  cursor: 'pointer',
  color: '#999'
});
var translucent = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
  opacity: 0.6
});
var footer = (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)(csstips__WEBPACK_IMPORTED_MODULE_2__.flexRoot, (0,csstips__WEBPACK_IMPORTED_MODULE_2__.padding)(0, 14), _objectSpread(_objectSpread(_objectSpread({
  borderTop: '1px solid #E9E9E9',
  height: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(36)
}, csstips__WEBPACK_IMPORTED_MODULE_2__.endJustified), csstips__WEBPACK_IMPORTED_MODULE_2__.center), {}, {
  color: '#666666',
  fontSize: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12),
  cursor: 'pointer'
}));
var primaryButtonContainerClassName = function primaryButtonContainerClassName(theme) {
  return (0,typestyle__WEBPACK_IMPORTED_MODULE_4__.style)({
    marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(13),
    color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.themePrimaryBackground(theme).toString(),
    $nest: {
      '&:hover': {
        color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.themePrimaryHoverBackground(theme).toString()
      },
      '&:active': {
        color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.themePrimaryActiveBackground(theme).toString()
      }
    }
  });
};

/***/ }),

/***/ "./src/types.ts":
/*!**********************!*\
  !*** ./src/types.ts ***!
  \**********************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);


/***/ }),

/***/ "../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js":
/*!***************************************************************************************************************************************************************************!*\
  !*** ../../.yarn/__virtual__/vue-tsx-support-virtual-5fcba29986/0/cache/vue-tsx-support-npm-2.3.3-2c646093c2-d5046aefd4.zip/node_modules/vue-tsx-support/enable-check.js ***!
  \***************************************************************************************************************************************************************************/
/***/ (function() {

// dummy js to avoid import error


/***/ }),

/***/ "core-js/modules/esnext.global-this.js":
/*!********************************************************!*\
  !*** external "core-js/modules/esnext.global-this.js" ***!
  \********************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_core_js_modules_esnext_global_this_js__;

/***/ }),

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/dialog":
/*!*************************************************************************!*\
  !*** external {"commonjs":"@splat/dialog","commonjs2":"@splat/dialog"} ***!
  \*************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_dialog__;

/***/ }),

/***/ "@splat/form":
/*!*********************************************************************!*\
  !*** external {"commonjs":"@splat/form","commonjs2":"@splat/form"} ***!
  \*********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form__;

/***/ }),

/***/ "@splat/form-item":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/form-item","commonjs2":"@splat/form-item"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_form_item__;

/***/ }),

/***/ "@splat/input":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/input","commonjs2":"@splat/input"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_input__;

/***/ }),

/***/ "@splat/textarea":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/textarea","commonjs2":"@splat/textarea"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_textarea__;

/***/ }),

/***/ "@splat/theme":
/*!***********************************************************************!*\
  !*** external {"commonjs":"@splat/theme","commonjs2":"@splat/theme"} ***!
  \***********************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_theme__;

/***/ }),

/***/ "@splat/validator":
/*!*******************************************************************************!*\
  !*** external {"commonjs":"@splat/validator","commonjs2":"@splat/validator"} ***!
  \*******************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__splat_validator__;

/***/ }),

/***/ "csstips":
/*!*************************************************************!*\
  !*** external {"commonjs":"csstips","commonjs2":"csstips"} ***!
  \*************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csstips__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "vue-property-decorator":
/*!*******************************************************************************************!*\
  !*** external {"commonjs":"vue-property-decorator","commonjs2":"vue-property-decorator"} ***!
  \*******************************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_property_decorator__;

/***/ }),

/***/ "vue-router":
/*!*******************************************************************!*\
  !*** external {"commonjs":"vue-router","commonjs2":"vue-router"} ***!
  \*******************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_router__;

/***/ }),

/***/ "vue-tsx-support":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"vue-tsx-support","commonjs2":"vue-tsx-support"} ***!
  \*****************************************************************************/
/***/ (function(module) {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_vue_tsx_support__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js":
/*!**********************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js ***!
  \**********************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _assertThisInitialized; }
/* harmony export */ });
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/classCallCheck.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _classCallCheck; }
/* harmony export */ });
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js":
/*!************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/createClass.js ***!
  \************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _getPrototypeOf; }
/* harmony export */ });
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js":
/*!*********************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/inherits.js ***!
  \*********************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _inherits; }
/* harmony export */ });
/* harmony import */ var _setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./setPrototypeOf.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js");

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) (0,_setPrototypeOf_js__WEBPACK_IMPORTED_MODULE_0__["default"])(subClass, superClass);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js":
/*!**************************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js ***!
  \**************************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _possibleConstructorReturn; }
/* harmony export */ });
/* harmony import */ var _typeof_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./typeof.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js");
/* harmony import */ var _assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./assertThisInitialized.js */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js");


function _possibleConstructorReturn(self, call) {
  if (call && ((0,_typeof_js__WEBPACK_IMPORTED_MODULE_0__["default"])(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return (0,_assertThisInitialized_js__WEBPACK_IMPORTED_MODULE_1__["default"])(self);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _setPrototypeOf; }
/* harmony export */ });
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js":
/*!*******************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/typeof.js ***!
  \*******************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _typeof; }
/* harmony export */ });
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SingleEditItem": function() { return /* reexport safe */ _singleItem__WEBPACK_IMPORTED_MODULE_2__["default"]; }
/* harmony export */ });
/* harmony import */ var _item__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./item */ "./src/item.tsx");
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./types */ "./src/types.ts");
/* harmony import */ var _singleItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./singleItem */ "./src/singleItem.tsx");


/* harmony default export */ __webpack_exports__["default"] = (_item__WEBPACK_IMPORTED_MODULE_0__["default"]);

}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map